export default "__VITE_ASSET__B8SR1qnj__"